export default import.meta.ROLLUP_FILE_URL_SdqWJ9bfP1mJq7Z32LA69A